function initCustomSelect() {
  const customSelects = document.querySelectorAll('.custom-select');

  customSelects.forEach((customSelect) => {
    const customSelectBtn = customSelect.querySelector('.custom-select__btn');
    const customSelectBtnText = customSelect.querySelector('.custom-select__btn-text');
    const customSelectList = customSelect.querySelector('.custom-select__list');
    const customSelectListItems = customSelect.querySelectorAll('.custom-select__list-item');
    const input = customSelect.querySelector('input');

    customSelectBtn.addEventListener('click', () => {
      customSelect.classList.toggle('is-active');
    });

    document.addEventListener('click', (e) => {
      if (!customSelect.contains(e.target)) {
        customSelect.classList.remove('is-active');
      }
    });

    customSelectListItems.forEach((customSelectListItem) => {
      customSelectListItem.addEventListener('click', () => {
        customSelectBtnText.textContent = customSelectListItem.textContent;
        customSelect.classList.remove('is-active');
        input.value = customSelectListItem.textContent;
      });
    });
  });
}

export {initCustomSelect};